import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// routing
import { Link } from "react-router-dom";
// types
import { UNSET_USER } from "../store/user/types";

const Header = () => {
  const [isMenuPage, setIsMenuPage] = useState(false);

  useEffect(() => {
    const pathName = window.location.pathname;
    if (pathName === "/menu") {
      setIsMenuPage(true);
    }
  }, [isMenuPage]);
  const isAuth = useSelector((state) => state.user.isAuth);

  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch({ type: UNSET_USER });
    window.location.replace("/");
  };

  return (
    <header id="header" className="fixed-top  header-transparent">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-3 m-auto">
            <div className="logo">
              <h1>
                <Link to="/#hero">Delicious</Link>
              </h1>
            </div>
          </div>
          <div className="col-md-9">
            <nav
              id="navbar"
              className="navbar order-last order-lg-0  float-right"
            >
              <ul id="navbar_items">
                <li>
                  <a className="nav-link active" href="/#hero">
                    Home
                  </a>
                </li>
                {/* {isAuth && (
                  <li>
                    <a className="nav-link" href="/menu">
                      Menu
                    </a>
                  </li>
                )} */}
                <li>
                  <a className="nav-link " href="/#gallery">
                    Gallery
                  </a>
                </li>
                <li>
                  <a className="nav-link " href="/menu">
                    Menu
                  </a>
                </li>
                {isAuth && (
                  <li>
                    <a className="nav-link" href="/#specials">
                      Specials
                    </a>
                  </li>
                )}
                <li>
                  <a className="nav-link " href="/#chefs">
                    Chefs
                  </a>
                </li>
                <li>
                  <a className="nav-link " href="/#contact">
                    Contact
                  </a>
                </li>

                {!isAuth ? (
                  <>
                    <li>
                      <a href="register" className="login nav-button">
                        Register
                      </a>
                    </li>
                    <li>
                      <a href="login" className="login nav-button">
                        Login
                      </a>
                    </li>
                  </>
                ) : (
                  <li>
                    <span onClick={handleLogout} className="login">
                      Logout
                    </span>
                  </li>
                )}
              </ul>
            </nav>

            <i
              className="fas fa-bars mobile-nav-toggle float-right"
              style={{ marginTop: -10 }}
            ></i>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
